import React from "react";
import GenericButton from "@ui-components/Button/GenericButton";
import { ReactComponent as IconCopy } from "@assets/Icons/IconCopy.svg";
import { ReactComponent as IconCheck } from "@assets/Icons/IconCheckSquared.svg";
import { useCopyFeedback } from "./useCopyFeedback";

/** Copies one log message; the icon turns into a check while the copy is fresh. */
export function CopyMessageButton({ message }: { message: string }) {
  const { copied, copy } = useCopyFeedback();

  const Icon = copied ? IconCheck : IconCopy;
  return (
    <GenericButton
      onClick={() => copy(message)}
      icon={<Icon className="w-5 h-5 text-semantic-text-secondary" />}
      isIconOnly
      variant="secondary"
      shape="ghost"
      size="sm"
      title={copied ? "Copied" : "Copy message"}
      aria-label={copied ? "Message copied" : "Copy message"}
    />
  );
}
